/**
 * @public
 * Creates a HTML element from a string.
 *
 * @param {String} htmlString: the HTML string to convert
 * @return {HTMLElement} HTML element result from string
 */
function createElementFromHTML(htmlString) {
  const div = document.createElement('div');
  div.innerHTML = htmlString.trim();
  return div.firstChild;
}

export default createElementFromHTML;
